import { makeStyles } from '@material-ui/core/styles';
import { maxWidthMap, TextColors } from '@/utils/constants';

const darkTheme = {
  root: {
    '& $dotsContainer, $dotsArrow': {
      color: TextColors.light,
    },
  },
};

const lightTheme = {
  root: {
    '& $dotsContainer, $dotsArrow': {
      color: TextColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      width: '100%',
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
    },
    swiper: {
      width: '100%',

      '$root &.swiper-container': {
        overflow: 'visible',
      },

      '& [slot="container-end"]': {
        [muiTheme.breakpoints.up('md')]: {
          position: 'absolute',
          top: '50%',
          transform: 'translateY(109px)',
          left: 0,
          paddingLeft: '608px',
          zIndex: 1,
          width: '100%',
          height: '0',
        },
      },

      '& > .swiper-wrapper': {
        [muiTheme.breakpoints.up('md')]: {
          alignItems: 'center',
          transform: 'translateX(-250px) !important',
        },
      },
    },
    cardList: {
      display: 'block',

      '& .card-list-item': {
        display: 'inline-block !important',
        margin: muiTheme.spacing(0, 2),
      },
    },
    list: {},
    sliderNavigation: {
      position: 'static',
    },
    sliderCard: {
      [muiTheme.breakpoints.up('md')]: {
        height: '220px !important',
        width: '220px !important',

        '& > *': {
          height: '220px !important',
          width: '220px !important',
        },
      },
    },
    sliderActiveCard: {
      [muiTheme.breakpoints.down('sm')]: {
        width: '100% !important',
        '& > *': {
          width: '100% !important',
        },
      },

      [muiTheme.breakpoints.up('md')]: {
        height: 'auto !important',
        width: '542px !important',

        '& > *': {
          height: 'auto !important',
          width: '542px !important',
        },
        '& .card-actions': {
          padding: '8px 0',
        },
      },
    },
    dotsArrow: {
      cursor: 'pointer',
    },
    dotsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    image: {},
    linkContainer: {},
    slider: {
      '&': {
        display: 'flex',
        flexFlow: 'column nowrap',
        maxWidth: '150px',
        width: '100%',
        '& .slick-dots': {
          maxWidth: maxWidthMap.large,
        },
        '& .slick-slide > div': {
          marginRight: 0,
        },
        [muiTheme.breakpoints.up('md')]: {
          maxWidth: '100%',

          '& .slick-slide > div': {
            marginRight: muiTheme.spacing(0, 2),
          },
        },
      },
    },
  }),
  { name: 'GenCardCarouselContentCardCarousel' },
);

export default useStyles;
